<template>
  <div>
    <md-table v-model="Nodes"  style="  background-color:#4CAF50;">
      <md-table-row slot="md-table-row" slot-scope="{ item }" @click.native="getpath(item.NodeId)">
        <md-table-cell style="  font-weight: bold;" md-label="Nom de l'agriculteur">{{ item.FarmerName }}</md-table-cell>

                <md-table-cell md-label="Node Id" >{{ item.NodeId }}</md-table-cell>

        <!-- <md-table-cell md-label="City">{{ item.city }}</md-table-cell>
        <md-table-cell md-label="Salary">{{ item.salary }}</md-table-cell> -->
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import router from '../../routes'
import GetNodes from "@/services/NodeData";
export default {
  name: "simple-table",
  // props: {
  //   Nodes: {
  //     type: String,
  //     default: []
  //   },
  //   tableHeaderColor: {
  //     type: String,
  //     default: ""
  //   }
  // },
  data() {
    return {
      selected: [],
      Nodes: [
      ]
    };
  },
  methods:{
    getpath(id){
      console.log(id)
      router.push(`/dashboard?id=${id}`)
      // window.location.href = "http://134.122.125.168:8081/#/dashboard?id="+id
    }
  },
   beforeCreate(){
    GetNodes.getNodes()
    .then(data =>{
      this.Nodes = data
      console.log(this.Nodes)
    })
  }
};
</script>
